import KeyValuePair from '@/modules/core/support/KeyValuePair'

export default class UnigestUser {
    public id = 0
    public name = ''
    public description = ''
    public email = ''

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            id: data.id || 0,
            name: data.name || '',
            description: data.description || '',
            email: data.email || '',
        })
    }
}
